import styled, { css } from 'styled-components';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { devices } from '../../../juristec-ui/core/breakpoints';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const getDeviceLayoutSizes = (layoutType) => {
  switch (layoutType) {
    case 'tablet':
      return css`
        margin-left: auto;
        margin-right: auto;
        width: 80%;
      `;
    case 'mobile':
      return css`
        margin-left: auto;
        margin-right: auto;
        width: 50%;
      `;
    case 'fixed':
      return css`
        margin-left: auto;
        margin-right: auto;
        overflow-x: auto;
      `;
    default:
      return css`
        margin-left: 5%;
        margin-right: 5%;
      `;
  }
};

const StyledOuterGridKpiLayout = styled.main`
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: auto;
  padding: 5px;
  padding-bottom: 65px;
  margin-top: 0rem;
  box-sizing: border-box;
  ${({ layoutType }) => getDeviceLayoutSizes(layoutType)}
  height: ${({ isFullScreen, showToolbar }) => (isFullScreen ? '100vh' : `calc(100vh - ${showToolbar ? 166 : 108}px)`)};
  @media ${devices.tablet} {
    margin: 0px 0px;
    width: 100%;
    height: calc(100vh - ${({ showToolbar }) => (showToolbar ? 170 : 112)}px);
  }

  @media ${devices.phoneS} {
    margin: 0px 0px;
    width: 100%;
    height: calc(100vh - 112px);
  } ;
`;

/**
 * Função que irá retornar css dinamico dependendo se esta em modo edicao ou nao do painel
 * @param {boolean} editPainel
 * @param {boolean} multiSelection
 * @returns css code
 */
const effectGridKpiCard = (editPainel, multiSelection) => {
  if (editPainel || multiSelection) {
    return css`
      box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
        0px 1px 8px 0px rgba(0, 0, 0, 0.12);
      & .iframeComponent {
        pointer-events: none;
      }
      ${editPainel && css`
        cursor: move;
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;
  
        &:active {
          cursor: grabbing;
          cursor: -moz-grabbing;
          cursor: -webkit-grabbing;
        }
      `}
    `;
  }
  return '';
};

const StyledResponsiveReactGridKpiLayout = styled(ResponsiveReactGridLayout)`
  width: ${({ fixedSize }) => (fixedSize ? `${fixedSize}px` : '100%')};
  margin: auto;
  & > div {
    &:hover {
      ${({ editPainel, multiSelection }) => effectGridKpiCard(editPainel, multiSelection)}
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      pointer-events: none;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      border: ${({ editPainel, multiSelection }) => (editPainel || multiSelection ? 'dashed 2px #a9a9a9' : 'solid 2px transparent')};
    }

    & .card-kpi * {
      ${({ editPainel, multiSelection }) => ((editPainel || multiSelection) && css`
        user-select: none;
        pointer-events: none;
      `)}
    }

    padding: 0px;
    margin: 0px;
    position: relative;
    /* overflow: hidden; */
  }
  & .react-resizable-handle-s {
    cursor: ns-resize !important;
  }
  & .react-resizable-handle-e {
    cursor: ew-resize !important;
  }
`;

const StyledGridKpiCard = styled.div`
  height: 100%;
`;

const StyledPopover2 = styled.div`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  position: absolute;
  right: 100%;
  top: 0%;
`;

const ExitFullScreen = styled.div`
  position: fixed;
  top: 50px;
  left: 50px;
`;

const EmptyReportCard = styled.div`
  box-sizing: border-box;
  min-height: 240px;
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  color: ${({ theme }) => theme.color};
  background: ${({ theme }) => theme.tableBackground};
  border: 1px dashed ${({ theme }) => theme.containerLine};
  border-radius: 12px;

  .empty-report-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: ${({ theme }) => theme.controllersLabel};
    color: ${({ theme }) => theme.primary};
  }
  .empty-report-icon svg { width: 28px; height: 28px; fill: currentColor; }
  h3 { margin: 0; font-size: 16px; font-weight: 600; }
  p { margin: 0; max-width: 380px; font-size: 13px; line-height: 1.6; }
  button { margin-top: 4px; }
  button:focus-visible { outline: 3px solid ${({ theme }) => theme.warning}; outline-offset: 3px; }
`;

const CardWrapper = styled.div`
  ${({ isSelected, theme }) => isSelected && css`
    &:after {
      content: '';
      background: repeating-linear-gradient(
        45deg,
        ${theme.info}5a,
        ${theme.info}5a 10px,
        ${theme.info}8a 10px,
        ${theme.info}8a 20px
      );
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      overflow: hidden;
      pointer-events: none;
    }
  `}
`;

export {
  StyledResponsiveReactGridKpiLayout,
  StyledOuterGridKpiLayout,
  StyledGridKpiCard,
  StyledPopover2,
  ExitFullScreen,
  CardWrapper,
  EmptyReportCard,
};
